import axios from "axios";
import {setStorage,getAuthHeader,removeStorage} from '../config/Utils';


export const loginAmbassador=async(body)=>{
    const url=`${process.env.REACT_APP_API_URL}/ambassador/login`
    return axios.post(url,body).then((res)=>{
        if (res.data.status) {
            setStorage("token", res.data.data.token);
            setStorage("ambDetail", res.data.data);
        }
        return res.data
    })
}

export const ForgotPassword=async(body)=>{
    const url=`${process.env.REACT_APP_API_URL}/ambassador/forgot-password`
    return axios.post(url,body).then((res)=>{
        return res.data
    })
}

export const resetPassword=async(body)=>{
    const url=`${process.env.REACT_APP_API_URL}/ambassador/reset-password`
    return axios.post(url,body).then((res)=>{
        return res.data
    })
}


export const changePassword=async(body)=>{
    const url=`${process.env.REACT_APP_API_URL}/ambassador/change-password`
    return axios.post(url,body,getAuthHeader()).then((res)=>{
        return res.data
    })
}

export const getOnBoardStudentList=()=>{
    const url=`${process.env.REACT_APP_API_URL}/ambassador/onboard-students-list`
    return axios.get(url,getAuthHeader()).then((res)=>{
        return res.data
    })
}

export const onBoardStudent=async(body)=>{
    const url=`${process.env.REACT_APP_API_URL}/ambassador/onboard-student`
    return axios.post(url,body,getAuthHeader()).then((res)=>{
        return res.data
    })  
}

export const getAmbassadorDetail = async() => {
    const url =  `${process.env.REACT_APP_API_URL}/ambassador/detail`
    return axios.get(url,getAuthHeader()).then((res)=>{
        if (res.data.status) {
            removeStorage('ambDetail')
            setStorage("ambDetail", res.data.data);
        }
        return res.data
    })
}

export const validateAmbassador = async(slug) => {
    const url =  `${process.env.REACT_APP_API_URL}/ambassador/validation?s=${slug}`
    return axios.get(url).then((res)=>{
        return res.data
    }) 
}



export const bulkOnboardStudent = async(body) => {
    const url =  `${process.env.REACT_APP_API_URL}/ambassador/bulk/onboard`
    return axios.post(url,body,getAuthHeader()).then((res)=>{
        return res.data
    }) 
}

export const bulkUploadnewApi = async(body) => {
    const url =  `http://172.25.19.51/overseas_v1/api/bulkuploadeapi`
    return axios.post(url,body,getAuthHeader()).then((res)=>{
        return res.data
    }) 
}

export const getBulkStudentDetails = async(slug) => {
    const url =  `${process.env.REACT_APP_API_URL}/bulkonboard/detail`
    return axios.get(url,getAuthHeader()).then((res)=>{
        return res.data
    }) 
}



